import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { loadFiltersFromStorage } from '../utils/filterPersistenceUtils';
import { restoreFiltersFromStorage } from '../store/filterPersistence/filterPersistenceReducer';

/**
 * Hook that initializes filter persistence on application startup
 * Restores filter state from localStorage and dispatches the restore action
 */
export const useFilterPersistence = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    // Load saved filters from localStorage
    const savedFilters = loadFiltersFromStorage();
    
    if (savedFilters) {
      // Dispatch action to restore filters to Redux state
      dispatch(restoreFiltersFromStorage(savedFilters));
    }
  }, [dispatch]);
};

export default useFilterPersistence;
